import React from 'react';
import { Link } from '@mui/material';

export default function TempleCard({
  name,
  location,
  image,
  viewLink = '#',
  historyLink = '#',
}) {
  return (
    <div className="temple-custom-card">
      <Link href={viewLink} sx={{ textDecoration: 'none', display: 'block' }}>
        <div className="card-image-wrap">
          <img
            src={image || '/assets/banner/detail-image.svg'}
            alt={name}
            loading="lazy"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = '/assets/banner/detail-image.svg';
            }}
          />
        </div>
      </Link>

      <div className="card-info-wrap">
        <Link href={viewLink} sx={{ textDecoration: 'none' }}>
          <h3 className="card-temple-title" title={name}>
            {name}
          </h3>
        </Link>
        <p className="card-temple-location">{location}</p>

        <div className="card-buttons-row">
          <Link
            href={historyLink || viewLink}
            className="btn-temple-history"
            sx={{ textDecoration: 'none' }}
          >
            Temple history
          </Link>
          <Link
            href={viewLink}
            className="btn-view-temple"
            sx={{ textDecoration: 'none' }}
          >
            View Temple
          </Link>
        </div>
      </div>
    </div>
  );
}
